import React from 'react';

const ViewUnconfirmedDeliveriesScreen = () => {
	return <div>ViewUnconfirmedDeliveriesScreen</div>;
};

export default ViewUnconfirmedDeliveriesScreen;
